import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const ToDoEditDialog = ({
  open,
  onOpenChange,
  editForm,
  setEditForm,
  marketingList,
  websiteList,
  onSubmit,
  loading,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#1a1a1b] border-red-900/30 max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-red-50">Edit Member</DialogTitle>
          <DialogDescription className="text-gray-400">
            Update informasi member dan tambahkan catatan
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label htmlFor="edit-marketing" className="text-gray-300">Marketing</Label>
              <Select
                value={editForm.marketing_name}
                onValueChange={(value) => setEditForm({ ...editForm, marketing_name: value })}
              >
                <SelectTrigger className="bg-[#0f0f10] border-red-900/30 text-white" data-testid="edit-marketing-select">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent className="bg-[#1a1a1b] border-red-900/30 text-white">
                  {marketingList.map((item) => (
                    <SelectItem
                      key={item.id}
                      value={item.name}
                      className="text-white hover:bg-red-900/20 focus:bg-red-900/30 focus:text-white"
                    >
                      {item.name}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            <div className="space-y-2">
              <Label htmlFor="edit-website" className="text-gray-300">Website</Label>
              <Select
                value={editForm.website}
                onValueChange={(value) => setEditForm({ ...editForm, website: value })}
              >
                <SelectTrigger className="bg-[#0f0f10] border-red-900/30 text-white" data-testid="edit-website-select">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent className="bg-[#1a1a1b] border-red-900/30 text-white">
                  {websiteList.map((item) => (
                    <SelectItem
                      key={item.id}
                      value={item.name}
                      className="text-white hover:bg-red-900/20 focus:bg-red-900/30 focus:text-white"
                    >
                      {item.name}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            <div className="space-y-2">
              <Label htmlFor="edit-username" className="text-gray-300">Username</Label>
              <Input
                id="edit-username"
                value={editForm.username}
                onChange={(e) => setEditForm({ ...editForm, username: e.target.value })}
                required
                className="bg-[#0f0f10] border-red-900/30 text-white"
                data-testid="edit-username-input"
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="edit-kode-db" className="text-gray-300">Kode DB</Label>
              <Input
                id="edit-kode-db"
                value={editForm.kode_db}
                onChange={(e) => setEditForm({ ...editForm, kode_db: e.target.value })}
                required
                className="bg-[#0f0f10] border-red-900/30 text-white"
                data-testid="edit-kode-db-input"
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="edit-phone" className="text-gray-300">No. Handphone</Label>
              <Input
                id="edit-phone"
                value={editForm.phone}
                onChange={(e) => setEditForm({ ...editForm, phone: e.target.value })}
                required
                className="bg-[#0f0f10] border-red-900/30 text-white"
                data-testid="edit-phone-input"
              />
            </div>

            {editForm.member_type === "ndp" && (
              <div className="space-y-2">
                <Label htmlFor="edit-nominal-depo" className="text-gray-300">Nominal Depo</Label>
                <Input
                  id="edit-nominal-depo"
                  type="number"
                  step="0.01"
                  value={editForm.nominal_depo}
                  onChange={(e) => setEditForm({ ...editForm, nominal_depo: e.target.value })}
                  required
                  className="bg-[#0f0f10] border-red-900/30 text-white"
                  data-testid="edit-nominal-depo-input"
                />
              </div>
            )}
          </div>

          <div className="space-y-2">
            <Label htmlFor="edit-notes" className="text-gray-300">Catatan</Label>
            <Textarea
              id="edit-notes"
              value={editForm.notes}
              onChange={(e) => setEditForm({ ...editForm, notes: e.target.value })}
              placeholder="Tambahkan catatan untuk member ini..."
              rows={4}
              className="bg-[#0f0f10] border-red-900/30 text-white resize-none"
              data-testid="edit-notes-input"
            />
          </div>

          <div className="flex gap-3">
            <Button
              type="button"
              variant="outline"
              onClick={() => onOpenChange(false)}
              className="flex-1 border-red-900/30 text-white hover:bg-red-900/20"
              data-testid="cancel-edit-button"
            >
              Batal
            </Button>
            <Button
              type="submit"
              className="flex-1 bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800"
              disabled={loading}
              data-testid="save-edit-button"
            >
              {loading ? "Menyimpan..." : "Simpan Perubahan"}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default ToDoEditDialog;
